import { ColumnConfigType } from 'shared/types';
import { TablePrizeItemType } from 'entities/prize';

export const columnConfig: ColumnConfigType<TablePrizeItemType>[] = [
  {
    dataFieldName: 'id',
    name: 'ID',
    width: '6%',
  },
  {
    dataFieldName: 'name',
    name: 'Имя приза',
    width: '30%',
  },
  {
    dataFieldName: 'type',
    name: 'Тип',
    width: '16%',
  },
  {
    dataFieldName: 'min_start_date',
    name: 'Дата начала',
    width: '16%',
  },
  {
    dataFieldName: 'max_end_date',
    name: 'Дата окончания',
    width: '16%',
  },
];
